"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyModalStyleLink = exports.SankeyModalStyleNode = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyUtils_1 = require("../configmenus/SankeyUtils");
const fa_1 = require("react-icons/fa");
const SankeyMenuConfigurationNodesAttributes_1 = require("../configmenus/SankeyMenuConfigurationNodesAttributes");
const SankeyMenuConfigurationLinksAppearence_1 = require("../configmenus/SankeyMenuConfigurationLinksAppearence");
const SankeyModalStyleNode = (applicationContext, dict_variable_application_data, ref_show_style_node, ref_selected_style_node, ComponentUpdater, node_function, node_attribute_tab) => {
    const { t } = applicationContext;
    const { data } = dict_variable_application_data;
    const { updateComponentMenuConfigNodeAppearence } = ComponentUpdater;
    const { RedrawNodes } = node_function;
    const [selected_style_node, set_selected_style_node] = (0, react_1.useState)('default');
    ref_selected_style_node.current = selected_style_node;
    const [show_style_node, set_show_style_node] = (0, react_1.useState)(false);
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    ref_show_style_node.current = set_show_style_node;
    if (data.style_node && !Object.keys(data.style_node).includes(selected_style_node)) {
        set_selected_style_node('default');
    }
    const closeStyleEdition = () => {
        set_show_style_node(false);
    };
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_style_node, onHide: closeStyleEdition, size: 'lg' },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.esn'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: 'sankey-menu content_editon_elements' },
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
                            const new_style = (0, SankeyUtils_1.DefaultNodeStyle)();
                            new_style.name = 'New Style';
                            const new_id = 'style_node_' + String(new Date().getTime());
                            new_style.idNode = new_id;
                            data.style_node[new_id] = new_style;
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigNodeAppearence.current();
                            ref_selected_style_node.current = new_style.idNode;
                            set_selected_style_node(new_style.idNode);
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null)),
                    react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { style: { width: '50%' }, variant: "success", id: "dropdown-basic" }, (selected_style_node !== '') ? (0, SankeyUtils_1.CutName)(data.style_node[selected_style_node].name, 30) : 'Choix Style'),
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(data.style_node).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => {
                                    ref_selected_style_node.current = d;
                                    set_selected_style_node(d);
                                } }, data.style_node[d].name));
                        }))),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'danger', disabled: selected_style_node === 'default', onClick: () => {
                            Object.values(data.nodes).filter(n => n.style == selected_style_node).forEach(n => n.style = 'default');
                            delete data.style_node[selected_style_node];
                            const new_style = (Object.keys(data.style_node).length > 0) ? Object.keys(data.style_node)[0] : '';
                            set_selected_style_node(new_style);
                            ref_selected_style_node.current = new_style;
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigNodeAppearence.current();
                            RedrawNodes(Object.values(dict_variable_application_data.display_nodes));
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))),
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '30%' } }, t('Menu.ns')),
                    react_1.default.createElement(react_bootstrap_1.FormControl, { disabled: (selected_style_node === 'default') ? true : false, value: (selected_style_node !== '') ? data.style_node[selected_style_node].name : '', onChange: evt => {
                            data.style_node[selected_style_node].name = evt.target.value;
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigNodeAppearence.current();
                        } }))),
            (0, SankeyMenuConfigurationNodesAttributes_1.SankeyMenuConfigurationNodesAttributes)(t, node_attribute_tab, true))));
};
exports.SankeyModalStyleNode = SankeyModalStyleNode;
//Modal et fonctions pour l'edition et affectation des style de flux
const SankeyModalStyleLink = (applicationContext, dict_variable_application_data, dict_variable_elements_selected, ref_show_style_link, additional_link_appearence_items, link_function, ComponentUpdater) => {
    const { data } = dict_variable_application_data;
    const { t } = applicationContext;
    const { ref_selected_style_link } = dict_variable_elements_selected;
    const { updateComponentMenuConfigLink } = ComponentUpdater;
    const [selected_style_link, set_selected_style_link] = (0, react_1.useState)('default');
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    ref_selected_style_link.current = selected_style_link;
    const [show_style_link, set_show_style_link] = (0, react_1.useState)(false);
    ref_show_style_link.current = set_show_style_link;
    const ComponentUpdaterForStyle = {
        updateComponentMenuConfigNode: (0, react_1.useRef)(() => null),
        updateComponentMenuConfigNodeAppearence: (0, react_1.useRef)(() => null),
        updateComponentMenuConfigLink: (0, react_1.useRef)(() => setForceUpdate(!forceUpdate)),
        updateComponentToolbar: (0, react_1.useRef)(() => null),
        updateComponentMenuConfig: (0, react_1.useRef)(() => null),
        updateComponentMenuConfigLayout: (0, react_1.useRef)(() => null),
        updateComponentMenu: (0, react_1.useRef)(() => null),
        updateComponenTimeCheckpoint: (0, react_1.useRef)(() => null),
        updateComponentMenuNodeIOSelectSideNode: (0, react_1.useRef)([])
    };
    if (selected_style_link !== 'default') {
        set_selected_style_link('default');
    }
    const closeStyleEditionLink = () => {
        set_show_style_link(false);
    };
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_style_link, onHide: closeStyleEditionLink, size: 'lg' },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.esf'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: 'content_editon_elements' },
            react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
                            const new_style = (0, SankeyUtils_1.DefaultLinkStyle)();
                            new_style.name = 'New Style';
                            const new_id = 'style_link_' + String(new Date().getTime());
                            new_style.idLink = new_id;
                            data.style_link[new_id] = new_style;
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigLink.current();
                            set_selected_style_link(new_style.idLink);
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null)),
                    react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { style: { width: '50%' }, variant: "success", id: "dropdown-basic" }, (selected_style_link !== '') ? (0, SankeyUtils_1.CutName)(data.style_link[selected_style_link].name, 30) : 'Choix Style'),
                        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(data.style_link).map((d, i) => {
                            return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => { set_selected_style_link(d); } }, data.style_link[d].name));
                        }))),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'danger', disabled: selected_style_link === 'default', onClick: () => {
                            Object.values(data.links).filter(l => l.style == selected_style_link).forEach(l => l.style = 'default');
                            delete data.style_link[selected_style_link];
                            set_selected_style_link('default');
                            ref_selected_style_link.current = 'default';
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigLink.current();
                            link_function.RedrawLinks(Object.values(dict_variable_application_data.display_links));
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null)))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.ns'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { value: (selected_style_link !== '') ? data.style_link[selected_style_link].name : '', onChange: evt => {
                            data.style_link[selected_style_link].name = evt.target.value;
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigLink.current();
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { md: 12 }, (0, SankeyMenuConfigurationLinksAppearence_1.MenuConfigurationLinksAppearence)(dict_variable_application_data, dict_variable_elements_selected, applicationContext, additional_link_appearence_items, true, link_function, ComponentUpdaterForStyle, true))))));
};
exports.SankeyModalStyleLink = SankeyModalStyleLink;
